/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type RouteTypeEnum = 0 | 1 | 2;

export const RouteTypeEnum = {
    NUMBER_0: 0 as RouteTypeEnum,
    NUMBER_1: 1 as RouteTypeEnum,
    NUMBER_2: 2 as RouteTypeEnum
};
